export default __webpack_public_path__ + "static/media/ProW.bb06cf0f.jpg";